import { createFileRoute } from "@tanstack/react-router";
import { CustomAppView } from "src/components/views/customApps/CustomAppView.tsx";
import { CustomAppUserApi } from "src/api/generated/erp/customApps/api/customAppUserApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/apps/$customAppId")({
	staticData: {
		legacyViewKey: "customAppViews",
		listGeneratedViews: async () =>
			(await CustomAppUserApi.list()).map((app) => ({ id: app.customAppId, title: app.name })),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id, title },
		isActive,
	} = useKeptAliveGeneratedView();
	return <CustomAppView customAppId={id} title={title} isActive={isActive} />;
}
